'use strict';
const extendWithIcons = require('./progress-extend-with-icons'),
	baseConfigs = {
		'testing': require('./progress-config-testing'),
		'tasks': require('./progress-config-tasks')
	};
module.exports = function progressConfigurationBuild(configName, baseAssetUrl, iconSet, iconSize) {
	let baseConfig = baseConfigs[configName];
	if (iconSet) {
		baseConfig = extendWithIcons(baseConfig, baseAssetUrl + configName + '/' + iconSet + '/', iconSize);
	}
	return baseConfig;
};
